import { Component, computed, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { HomeDataService } from '../../services/home-data.service';
import { GaEventService } from '../../../../core/services/ga.service';
import {
  PARENT_ANALYTICS_LAYOUT,
  ParentAnalyticsEvents,
  ParentAnalyticsTabs,
} from '../../../../core/analytics/parent-analytics.events';

@Component({
  selector: 'app-home-toolbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, TranslatePipe],
  templateUrl: './home-toolbar.component.html',
  styleUrl: './home-toolbar.component.scss',
})
export class HomeToolbarComponent {
  #homeData = inject(HomeDataService);
  #analytics = inject(GaEventService);

  assignmentsLength = computed(() => this.#homeData.parentDuties().length);
  coursesCount = computed(() => this.#homeData.coursesCount());

  onTabClick(tab: typeof ParentAnalyticsTabs.DUTIES | typeof ParentAnalyticsTabs.COURSES): void {
    this.#analytics.sendEvent(ParentAnalyticsEvents.CLICK_TAB, {
      layout: PARENT_ANALYTICS_LAYOUT,
      tab_name: tab,
      source: 'home_toolbar',
    });
  }

  protected readonly tabs = ParentAnalyticsTabs;
}
